import Link from "next/link";
import { PostCard } from "~/components/blog/PostCard";
import type { PostMeta } from "~/lib/mdx";

type Props = {
  posts: PostMeta[];
};

export const RecentPostsSection: React.FC<Props> = ({ posts }) => {
  if (!posts.length) return null;

  return (
    <section className="bg-gray-50 px-4 py-12 sm:px-8 sm:py-16">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">
            Najnowsze artykuły z bloga
          </h2>
          <Link
            href="/poradnik/"
            className="text-sm font-medium text-sky-700 hover:text-sky-900"
          >
            Wszystkie artykuły →
          </Link>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((post) => (
            <PostCard key={post.slug} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
};
